import { InputNumber } from "antd";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";
import UploadInvoice from "../api/upload/UploadInvoice";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import React, { useEffect, useRef, useState } from "react";
import Modal1 from "../modals/Modal1";
import Payment from "./PaymentModal";
import createDocApi from "../api/database/createDocApi";
import { folder } from "jszip";
import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";
import {
  getDocDataById,
  getLocalStringFromFlutter,
  getRefFromId,
  queryCollection,
} from "../models/DataFunctions";
import MLTFGPT1 from "../textfields/MLTFGPT1";
import CustomAccordion from "../layout/CustomAccordion";
import Control from "../planning/Control";
import { EasySwitch } from "../textfields/EasySwitch";
import DropDownGPTMulti from "../dropdowns/DropDownGPTMulti";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import getControlPresginedUrls from "../api/presigned/getControlPresignedUrls";

const EventsControlsFolder = ({
  masterData,
  userData,
  folderData,
  navigateWorkspace,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [events, setEvents] = useState([]);
  const [controls, setControls] = useState([]);
  const [descriptions, setDescriptions] = useState([]);
  const [selected_operators, setSelectedOperators] = useState({});
  const [operators_options, setOperatorsOptions] = useState([]);

  const handleSyncEvent = async (ref, field, value) => {
    await updateDocDataFieldApi(ref, field, value, prefix);
    handleClickVariant("Evénement mis à jour", "success");
  };

  const [selectedControl, setSelectedControl] = useState(null);
  const [controlOpen, setControlOpen] = useState(false);

  const handleSelectControl = async (control_id) => {
    const filters = [
      {
        field: "cid",
        operator: "==",
        value: control_id,
      },
    ];
    const controls = (await queryCollection("control", filters)) || [];
    if (controls.length === 0) {
      handleClickVariant("Contrôle non trouvé", "error");
    } else {
      const token = await getOrRefreshFirebaseToken();
      await getControlPresginedUrls(controls[0].id, token, prefix);
      let fresh_control = await getDocDataById("control", controls[0].id);
      handleClickVariant("Contrôle trouvé", "success");
      setSelectedControl(fresh_control);
      setControlOpen(true);
    }
  };

  const [loadingEvent, setLoadingEvent] = useState(null);

  const handleSelectedOperators = async (newValues, event_id) => {
    setLoadingEvent(event_id);
    setSelectedOperators((prevSelectedOperators) => {
      let newSelectedOperators = { ...prevSelectedOperators };
      newSelectedOperators[event_id] = newValues;
      return newSelectedOperators;
    });
    await updateDocDataFieldApi(
      getRefFromId("event", event_id),
      "members_id",
      newValues,
      prefix
    );
    handleClickVariant("Opérateurs mis à jour", "success");
    setLoadingEvent(null);
  };

  const eventsAccoridionsRef = useRef([]);

  useEffect(() => {
    eventsAccoridionsRef.current = events.map(
      (_, i) => eventsAccoridionsRef.current[i] || React.createRef()
    );
  }, [events]);

  useEffect(() => {
    if (userData) {
      setTimeout(() => {
        let preferences = userData.preferences || {};
        let pinned = preferences.pinned || {};
        events.forEach((event, index) => {
          let id = "event_folder_slot_" + index;
          if (pinned[id] && eventsAccoridionsRef.current[index]?.current) {
            eventsAccoridionsRef.current[index].current.openAccordion();
          }
        });
      }, 100); // ← Juste pour tester le timing
    }
  }, [userData, events]);

  const handleDeleteEvent = async (ref, originalIndex) => {
    setLoadingEvent(ref.id);
    await deleteDocApi(ref, prefix);
    handleClickVariant("Evénement supprimé", "success");
    setEvents((prevEvents) => prevEvents.filter((_, i) => i !== originalIndex));
    setDescriptions((prevDescriptions) =>
      prevDescriptions.filter((_, i) => i !== originalIndex)
    );
    setLoadingEvent(null);
  };

  const handleGoToPlanningEvent = async (event) => {
    let date = getLocalStringFromFlutter(event.start);
    console.log("date", date);
    date = date.substring(0, 10);
    console.log("date", date);

    navigateWorkspace("/planning?date=" + date + "&event_id=" + event.id);
  };

  const handleEventUpdate = async (ref, originalIndex) => {
    await updateDocDataFieldApi(
      ref,
      "description",
      descriptions[originalIndex],
      prefix
    );
    handleClickVariant("Evénement mis à jour", "success");
    handleFetchData();
  };

  useEffect(() => {
    if (folderData) {
      handleFetchData(folderData);
    }
  }, [folderData]);

  const handleFetchData = async (fold) => {
    let folder = fold || folderData;
    if (!folder) return;
    let event_filters = [
      {
        field: "folder",
        operator: "==",
        value: folder.ref,
      },
    ];
    let events = (await queryCollection("event", event_filters)) || [];
    setEvents(events);
    setDescriptions(events.map((event) => event.description || ""));
    let filters_operators = [
      {
        field: "org_id",
        operator: "==",
        value: masterData.id,
      },
    ];
    let operators = await queryCollection("user", filters_operators);
    operators = operators.filter((operator) => operator.role === "operator");
    let options = operators.map((operator) => ({
      value: operator.id,
      label: operator.display_name || operator.email,
    }));
    let selected_operators = {};
    for (let event of events) {
      let members_id = event.members_id || [];

      selected_operators[event.id] = members_id;
    }
    setSelectedOperators(selected_operators);

    setOperatorsOptions(options);

    let controls = await queryCollection("control", [
      { field: "folder_ref", operator: "==", value: folder.ref },
    ]);
    setControls(controls);
  };

  return (
    <div className="flex flex-col w-full">
      <Modal1 isOpen={controlOpen} onClose={() => setControlOpen(false)}>
        <Control
          first_control={selectedControl}
          setControl={setSelectedControl}
          onClose={() => {
            setControlOpen(false);
          }}
          folder={folderData}
        ></Control>
      </Modal1>
      <div className="text-h1 font-semibold">Prestations collectives</div>
      <div className="flex flex-col gap-2 my-2">
        {folderData.collectif_options_selected?.map((option, index) => (
          <div className="flex flex-row gap-1 items-center">
            <Icon1 icon_name="pack" fill={"lightgrey"} size={20}></Icon1>
            <div className="text-h3 text-shadow_50 mx-2 flex-grow">
              {getCollectivePackName(option)}
            </div>
          </div>
        ))}
      </div>

      <div className="text-h1 font-semibold mt-4 mb-2">Contrôles</div>
      <div className="flex flex-row gap-1 items-center">
        <Icon1
          icon_name="control"
          fill={controls.length > 0 ? "#004aff" : "lightgrey"}
          size={20}
        ></Icon1>
        {controls.length > 1 && (
          <div className="text-h3 text-shadow_50 mx-2 flex-grow">
            {controls.length} contrôles réalisés
          </div>
        )}
        {controls.length === 1 && (
          <div className="text-h3 text-shadow_50 mx-2 flex-grow">
            {controls.length} contrôle réalisé
          </div>
        )}
        {controls.length === 0 && (
          <div className="text-h3 text-shadow_50 mx-2 flex-grow">
            Aucun contrôle réalisé
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 mt-2">
        {controls.map((control, index) => (
          <div key={index} className="flex flex-row gap-1 items-start ">
            <div
              className={`ml-8 flex flex-col 
             items-start justify-start  border-l-2  pl-2  ${control.revision ? "border-blue-500" : "border-shadow_25"}`}
            >
              <div className="flex flex-row gap-1 items-center">
                <div className="text-h3 text-shadow_50 mx-2 flex-grow ">
                  {new Date(control.date.seconds * 1000).toLocaleString()}
                </div>{" "}
                <SecondaryButton
                  onClick={() => handleSelectControl(control.cid)}
                  disabled={!control.cid}
                >
                  Ouvrir
                </SecondaryButton>
              </div>
              {control.revision && (
                <div className="flex flex-row  mx-2 items-center">
                  <Icon1
                    icon_name="restauration"
                    fill={"#004aff"}
                    size={20}
                  ></Icon1>

                  <div className="text-h3 text-shadow_50 ml-2 flex-grow">
                    Revisite {control.revision}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="text-h1 font-semibold mb-2 mt-4">Evènements</div>
      <div className="flex flex-row gap-1 items-center">
        <Icon1
          icon_name="date"
          fill={events.length > 0 ? "#004aff" : "lightgrey"}
          size={20}
        ></Icon1>
        {events.length > 1 && (
          <div className="text-h3 text-shadow_50 mx-2 flex-grow">
            {events.length} évènements
          </div>
        )}
        {events.length === 1 && (
          <div className="text-h3 text-shadow_50 mx-2 flex-grow">
            {events.length} évènement
          </div>
        )}
        {events.length === 0 && (
          <div className="text-h3 text-shadow_50 mx-2 flex-grow">
            Aucun évènement
          </div>
        )}
      </div>

      <div className="flex flex-col gap-1 mt-4">
        {events
          .map((event, originalIndex) => ({ event, originalIndex, description: descriptions[originalIndex] }))
          .sort((a, b) => b.event.start.seconds - a.event.start.seconds)
          .map(({ event, originalIndex, description }, index) => (
            <div key={index}>
              <CustomAccordion
                className="text-h2 text-shadow_50"
                userData={userData}
                nopin={false}
                id={"event_folder_slot_" + index}
                key={index}
                title={new Date(event.start?.seconds * 1000).toLocaleString()}
              >
                <div className="flex flex-col  w-full border-1 border-shadow_10 rounded-lg p-2">
                  <div className="flex flex-row items-start justify-start gap-3  w-full">
                    <div className="flex flex-col gap-1 text-h3 text-shadow_50  w-full">
                      <div className="flex flex-row gap-1 items-center">
                        <Icon1
                          icon_name="folder"
                          fill={event.folder ? "#004aff" : "lightgrey"}
                          size={20}
                        ></Icon1>
                        <div className="text-h3 text-shadow_50 ml-2">
                          Dossier créé
                        </div>
                      </div>
                      <div className="flex flex-row gap-1 items-center ">
                        <Icon1
                          icon_name="done3"
                          fill={event.rdv_confirmed ? "#004aff" : "lightgrey"}
                          size={20}
                        ></Icon1>
                        <div className="text-h3 text-shadow_50 ml-2 flex-grow">
                          RDV confirmé
                        </div>{" "}
                        <EasySwitch
                          checked={event.rdv_confirmed}
                          onChange={(checked) => {
                            setEvents((prevEvents) =>
                              prevEvents.map((ev, i) =>
                                i === index
                                  ? {
                                      ...ev,
                                      rdv_confirmed: checked,
                                    }
                                  : ev
                              )
                            );
                            handleSyncEvent(
                              event.ref,
                              "rdv_confirmed",
                              checked
                            );
                          }}
                        />
                      </div>
                      <div className="flex flex-row gap-1 items-center w-full">
                        <Icon1
                          icon_name="document"
                          fill={
                            event.documents_completed ? "#004aff" : "lightgrey"
                          }
                          size={20}
                        ></Icon1>

                        <div className="text-h3 text-shadow_50 ml-2 flex-grow">
                          Documents complétés
                        </div>
                        <EasySwitch
                          checked={event.documents_completed}
                          onChange={(checked) => {
                            setEvents((prevEvents) =>
                              prevEvents.map((ev, i) =>
                                i === index
                                  ? {
                                      ...ev,
                                      documents_completed: checked,
                                    }
                                  : ev
                              )
                            );
                            handleSyncEvent(
                              event.ref,
                              "documents_completed",
                              checked
                            );
                          }}
                        />
                      </div>
                      {event.revision && (
                        <div className="flex flex-row gap-1 items-center">
                          <Icon1
                            icon_name="restauration"
                            fill={"#004aff"}
                            size={20}
                          ></Icon1>

                          <div className="text-h3 text-shadow_50 ml-2 flex-grow">
                            Revisite {event.revision}
                          </div>
                        </div>
                      )}
                      <div className="flex flex-row gap-2 items-center">
                        <DropDownGPTMulti
                          className="w-full"
                          label="Opérateurs"
                          value={selected_operators[event.id]}
                          items={operators_options}
                          onChange={(newValues) =>
                            handleSelectedOperators(newValues, event.id)
                          }
                        ></DropDownGPTMulti>
                        {loadingEvent === event.id && (
                          <SmallSpinner loading={true}></SmallSpinner>
                        )}{" "}
                      </div>
                    </div>{" "}
                  </div>
                  <div className="flex flex-col mt-2 ">
                    <div className=" w-full ">
                      <MLTFGPT1
                        value={description}
                        onChange={(e) =>
                          setDescriptions((prevDescriptions) =>
                            prevDescriptions.map((desc, i) =>
                              i === originalIndex ? e.target.value : desc
                            )
                          )
                        }
                      />
                    </div>
                    <div className=" flex flex-row justify-end w-full mt-1 gap-2">
                      <SecondaryButton
                        onClick={() => handleDeleteEvent(event.ref, originalIndex)}
                      >
                        Supprimer
                      </SecondaryButton>
                      <PrimaryButton
                        onClick={() => handleGoToPlanningEvent(event)}
                      >
                        Voir
                      </PrimaryButton>
                      <PrimaryButton
                        onClick={() => handleEventUpdate(event.ref, originalIndex)}
                        disabled={description === event.description}
                      >
                        Enregistrer
                      </PrimaryButton>
                    </div>
                  </div>
                </div>
              </CustomAccordion>
            </div>
          ))}
      </div>
    </div>
  );
};

export default EventsControlsFolder;

export const getCollectivePackName = (key) => {
  const packNames = {
    infiltrometrie: "Infiltrométrie",
    ventilation: "Ventilation",
    acoustique: "Acoustique",
    promevent: "Promevent",
    dpe: "DPE",
  };
  return packNames[key] || "Pack inconnu";
};
